module.exports = __webpack_public_path__ + "static/media/31-5.008b7bbc.mp3";